var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cost-confirmation-summary" },
    [
      _c(
        "basic-container",
        [
          _c("CostSearch", {
            attrs: {
              searchForm: _vm.searchForm,
              partnerOptions: _vm.partnerOptions,
              channelOptions: _vm.channelOptions,
            },
            on: { search: _vm.handleSearch, export: _vm.handleExport },
          }),
          _c(
            "div",
            { staticClass: "table-container" },
            [
              _c("CostTable", {
                attrs: {
                  tableData: _vm.tableData,
                  loading: _vm.loading,
                  summaryData: _vm.summaryData,
                },
              }),
              _c(
                "div",
                { staticClass: "pagination-container" },
                [
                  _c("ElementPagination", {
                    attrs: {
                      "current-page": _vm.page.current,
                      "page-sizes": [10, 20, 50, 100],
                      "page-size": _vm.page.size,
                      total: _vm.page.total,
                      layout: "total, sizes, prev, pager, next, jumper",
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }